import { IRequesterInfo } from "../../../../base/models"
import { ClientProxy } from "../../../../base/proxy/clientProxy"
import { UserMenuJson } from "../models/models"

export class SetDefault extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo, userId: number) {
    super({
      url: `admin/admin-menu/set-default/${userId}`,
      requesterInfo,
    })
  }

  public async SetDefault(): Promise<UserMenuJson> {
    return await this.postAsync<UserMenuJson>()
  }
}
